module.exports = __webpack_public_path__ + "img/blue_stripes_bg_v2.25af97c3.png";